import React from 'react';
import { Route, Switch } from 'react-router-dom';

import GeneralReport from 'features/generalReport/view';

export const GeneralReportModule = <Route key="/general-report" path="/general-report" component={GeneralReport} />;
